<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-6 col-xs-12 plr-7">
        <h1
          class="mt-2 mb-4 center color-primary"
          style="font-family: Comfortaa-Bold"
        >
          Jovool
        </h1>

        <div>
          <h3>COMPLETE SEU CADASTRO</h3>
          <inputform
            v-model="recruiter.name"
            type="text"
            label="NOME COMPLETO"
            :field="$v.recruiter.name"
          />
          <inputform
            v-model="recruiter.business_name"
            type="text"
            label="NOME DA SUA EMPRESA"
            :field="$v.recruiter.business_name"
          />

          <div class="form-group">
            <label>CELULAR</label>
            <input
              class="form-control"
              type="text"
              v-model="recruiter.mobile_phone"
              v-mask="'+## (##) #####-####'"
              :class="{
                'is-invalid': $v.recruiter.mobile_phone.$error,
                'is-valid': !$v.recruiter.mobile_phone.$invalid,
              }"
            />
          </div>
          <label>
            <input v-model="recruiter.accept_terms" type="checkbox" />ACEITO OS
            <a href="#">TERMOS DE USO</a>
          </label>
          <label>
            <input v-model="recruiter.accept_marketing" type="checkbox" />
            GOSTARIA DE RECEBER AS NOVIDADES POR EMAIL
          </label>

          <button
            :disabled="load"
            @click="updateRecruiter"
            type="button"
            class="btn btn-lg btn-success full mt-3"
          >
            <span v-show="!load">Salvar</span>
            <div v-show="load" class="spinner-border text-light" role="status">
              <span class="sr-only"></span>
            </div>
          </button>
        </div>
      </div>
      <div
        class="col-lg-6 center col-xs-12 p-7 loginPanel"
        style="min-height: 100vh"
      ></div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import axios from "axios";
export default {
  props: ["name"],
  mounted() {
    if (this.name) {
      this.recruiter.name = this.name;
    }
  },
  data: () => ({
    load: false,
    recruiter: {
      name: "",
      business_name: "",
      mobile_phone: "",
      accept_terms: false,
      accept_marketing: false,
    },
  }),
  methods: {
    updateRecruiter() {
      this.$v.recruiter.$touch();
      if (this.$v.recruiter.$error) {
        return;
      }
      if (!this.recruiter.accept_terms) {
        this.$toast.error("Para continuar aceite os termos de uso", {
          position: "top",
        });
        return;
      }

      this.load = true;
      axios
        .put("/recruiters/profile", { recruiter: this.recruiter })
        .then((response) => {
          this.load = false;
          window.location = "/recruiters/dashboard";
        })
        .catch((error) => {
          console.log(error);
          this.load = false;
          this.$toast.error("Erro ao atualizar o perfil", { position: "top" });
          return;
        });
    },
  },
  validations: {
    recruiter: {
      name: { required },
      business_name: { required },
      mobile_phone: { required },
    },
  },
};
</script>